if (!customElements.get('enquiry-form')) {
  customElements.define(
    'enquiry-form',
    class EnquiryForm extends HTMLElement {
      connectedCallback() {
        this.calendlyLoaded = false;
        this.initTabs();
        this.initChips();
        this.initTracking();
      }

      initTracking() {
        const ref = this.querySelector('[data-enquiry-ref]');
        const utm = this.querySelector('[data-enquiry-utm]');
        if (ref) {
          let value = 'Direct or unknown';
          if (document.referrer) {
            try {
              const from = new URL(document.referrer);
              value = from.host === location.host ? from.pathname : document.referrer;
            } catch (error) {
              value = document.referrer;
            }
          }
          ref.value = value;
        }
        if (utm) {
          const params = new URLSearchParams(location.search);
          const parts = [];
          params.forEach((paramValue, key) => {
            if (key.indexOf('utm_') === 0 || key === 'ref' || key === 'gclid' || key === 'fbclid') {
              parts.push(key + '=' + paramValue);
            }
          });
          utm.value = parts.join(', ');
        }
      }

      initTabs() {
        const tabs = this.querySelectorAll('[data-tab]');
        if (!tabs.length) return;
        tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.openTab(tab.dataset.tab));
        });
        // After a submit, the page reloads: keep the form tab visible so the
        // success or error message is seen.
        if (this.hasAttribute('data-posted')) this.openTab('enquiry');
      }

      openTab(name) {
        this.querySelectorAll('[data-tab]').forEach((tab) => {
          const on = tab.dataset.tab === name;
          tab.classList.toggle('enquiry-form__tab--on', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        this.querySelectorAll('[data-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.panel !== name;
        });
        if (name === 'book') this.loadCalendly();
      }

      loadCalendly() {
        const url = this.dataset.calendly;
        const holder = this.querySelector('[data-cal]');
        if (!url || !holder || this.calendlyLoaded) return;
        this.calendlyLoaded = true;
        holder.innerHTML = '';
        const widget = document.createElement('div');
        widget.className = 'calendly-inline-widget enquiry-form__cal-widget';
        widget.setAttribute('data-url', url);
        widget.style.minWidth = '320px';
        widget.style.height = '700px';
        holder.appendChild(widget);
        if (!document.querySelector('script[src*="assets.calendly.com"]')) {
          const script = document.createElement('script');
          script.src = 'https://assets.calendly.com/assets/external/widget.js';
          script.async = true;
          document.head.appendChild(script);
        } else if (window.Calendly) {
          window.Calendly.initInlineWidget({ url: url, parentElement: widget });
        }
      }

      initChips() {
        const boxes = this.querySelectorAll('.enquiry-form__chip-input');
        const hidden = this.querySelector('[data-enquiry-services]');
        if (!boxes.length || !hidden) return;
        const sync = () => {
          const picked = [];
          boxes.forEach((box) => {
            if (box.checked) picked.push(box.value);
          });
          hidden.value = picked.join(', ');
        };
        boxes.forEach((box) => box.addEventListener('change', sync));
        sync();
        const form = hidden.closest('form');
        const error = this.querySelector('[data-chips-error]');
        if (form) {
          form.addEventListener('submit', (event) => {
            if (hidden.value === '') {
              event.preventDefault();
              if (error) {
                error.hidden = false;
                error.scrollIntoView({ block: 'center', behavior: 'smooth' });
              }
            }
          });
          boxes.forEach((box) =>
            box.addEventListener('change', () => {
              if (error && hidden.value !== '') error.hidden = true;
            })
          );
        }
      }
    }
  );
}